import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=1fb7495d&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=1fb7495d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7495d",
  null
  
)

export default component.exports